/* eslint-disable object-curly-spacing */ 
/* eslint-disable no-undef */ 
/* eslint-disable own-handles */ 
/* eslint-disable no-innerhtml-assign */ 
/* eslint-disable consistent-method-names */ 
/* eslint-disable no-jsdoc */ 
define(['../selector'], function(selector) {
    'use strict';
    var properties = [
        'address',
        'dist',
        'entryPoints',
        'position',
        'score',
        'poi',
        'type',
        'addressRanges',
        'boundingBox',
        'entityType',
        'viewport',
        'dataSources'
    ].join(', ');
    return function(json) {
        return selector(json, 'results', properties);
    };
});



// WEBPACK FOOTER //
// ./model/search/search.js